import { Box, Button, Text, Tooltip } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import type { UsePaginationReturn } from '../hooks/usePagination';

export function SmallPagination({
	pagination,
	totalItems,
}: { pagination: UsePaginationReturn; totalItems: number }) {
	return (
		<>
			<Tooltip
				label={
					<Text
						size={'sm'}
					>{`Page ${pagination.value.pageNumber}/${Math.ceil(totalItems / pagination.value.pageSize)}`}</Text>
				}
			>
				<Box>
					<Button
						color={'medepos.1'}
						variant={'transparent'}
						onClick={() =>
							pagination.setPageNumber(pagination.value.pageNumber - 1)
						}
						disabled={pagination.value.pageNumber === 1}
					>
						<IconChevronLeft size={'1.5rem'} />
					</Button>
					<Button
						color={'medepos.1'}
						variant={'transparent'}
						onClick={() =>
							pagination.setPageNumber(pagination.value.pageNumber + 1)
						}
						disabled={
							pagination.value.pageNumber ===
							Math.ceil(totalItems / pagination.value.pageSize)
						}
					>
						<IconChevronRight size={'1.5rem'} />
					</Button>
				</Box>
			</Tooltip>
		</>
	);
}
